import { ValidatedTree } from "../Pages/MapPage/Popup/MapPopup";
import findIndex from "lodash/findIndex";
import DBService, { TABLE_VALIDATED_QUEUE } from "./DBService";

const TREE_COUNT_INDEX = 'treeCount';
const VALIDATED_TREES_INDEX = 'validated-trees';


// trees COUNTER
export function incrementTrees(numberOfTrees: any): number {
  const currentCount = getTreeCount();
  const newCount = String(currentCount + parseInt(String(numberOfTrees)));
  setTreeCount(newCount);
  return parseInt(newCount);
}

export function decrementTrees(numberOfTrees: any): number {
  const currentCount = getTreeCount();
  const newCount = String(currentCount - parseInt(String(numberOfTrees)));
  setTreeCount(newCount);
  return parseInt(newCount);
}

export function setTreeCount(count: any) {
  localStorage.setItem(TREE_COUNT_INDEX, String(count));
}

export function getTreeCount(): number {
  return parseInt(String(localStorage.getItem(TREE_COUNT_INDEX)));
}

// VALIDATED trees
export function getValidatedTrees(): ValidatedTree[] {
  const stored = localStorage.getItem(VALIDATED_TREES_INDEX);
  if (stored === null) {
    return [];
  }
  return JSON.parse(stored);
}

export function addValidatedTree(tree: ValidatedTree) {
  const trees = getValidatedTrees();
  const index = findIndex(trees, { 'id': tree.id });
  if (index === -1) {
    trees.push(tree);
  }
  localStorage.setItem(VALIDATED_TREES_INDEX, JSON.stringify(trees));
}

export function removeValidatedTree(treeIndex: string) {
  const trees = getValidatedTrees();
  const treeArrayIndex = findIndex(trees, { 'id': treeIndex });
  if (treeArrayIndex > -1) {
    delete trees[treeArrayIndex];
  }
  localStorage.setItem(VALIDATED_TREES_INDEX, JSON.stringify(trees.filter(tree => tree !== null)));
}
// ASYNC VALIDATED trees (IndexedDB)
export async function getValidatedTreesAsync(): Promise<ValidatedTree[]> {
  const trees = await DBService.getAllValue(TABLE_VALIDATED_QUEUE);
  return trees || [];
}

export async function addValidatedTreeAsync(tree: ValidatedTree) {
  // Use tree.id as the key in IndexedDB for easy updates/checks
  await DBService.putValue(TABLE_VALIDATED_QUEUE, tree, tree.id);

  // Also update legacy localStorage for backward compatibility if needed, 
  // though we should move away from it.
  // addValidatedTree(tree);
}

export async function removeValidatedTreeAsync(treeId: string) {
  await DBService.deleteValue(TABLE_VALIDATED_QUEUE, treeId);
  removeValidatedTree(treeId);
}
